import { createWorkerAction } from '../../lib';

export const pubSubPublish = createWorkerAction('pubSubPublish');
